import React, { useEffect, useRef, useState } from "react";
import { Definition } from "../../../../../../data/Definition";
import Stats from "../../../../components/Elements/StatsPlotly";
import Widget from "../../../../components/Elements/Widget";
import { useStore } from "../../../../providers/AppProvider";
import { Field, StatValue, Zone } from "../../../../types/types";
import { queryDwZoneMetric } from "../../../../utils/dwHelpers";
import { SETTING_SEASON_YEAR } from "../../../../utils/settings";
import { dcRound } from "../../../../utils/misc";
import { min } from "lodash";

const CACHE_SIZE = 20;

interface DwZoneStatWidgetProps {
    field: Field;
    name: string;
    description: string;
    metric: 'productivity' | 'stress';
    changeInverted?: boolean;
    dateSelected: string | null;
    selectedZoneName: string | null;
    selectedZoneId: string | null;
    selectedZoneSetId: string | null;
    zones: Zone[] | null;
    zoneData: any;
    setZoneData: Function;
    productivityMaxMin?: {min: number, max: number};
}

const DwZoneStatWidget = ({ field, name, description, metric, changeInverted=false, dateSelected, selectedZoneName, selectedZoneId, selectedZoneSetId, zones, zoneData, setZoneData, productivityMaxMin }: DwZoneStatWidgetProps) => {
    const { state, loading, settings } = useStore();

    const [dataAllZones, setDataAllZones] = useState<any>(null);
    const [dataLoading, setDataLoading] = useState<boolean>(false);

    const { current: cache} = useRef({});

    useEffect(() => {
        console.log("A061824 selectedZoneId", selectedZoneId);
        if(!dataAllZones || dataAllZones.length === 0) {
            console.log("XXX041024 zoneData", zoneData)
            console.log("XXX041024 metric", metric)
            
            setZoneData((prevZoneData:any) => {
                console.log("XXX041024 prevZoneData", prevZoneData)
                let tempPrevZoneData = {...prevZoneData};
                tempPrevZoneData[metric] = null;
                return tempPrevZoneData;
            });    
            return;
        }
        console.log("B032924 dataAllZones", dataAllZones);
        let _dataAllZones = dataAllZones.map((d:any) => {
            if (metric === 'productivity') {
                const scale = 1 / (20000-12000);
                let min = productivityMaxMin ? productivityMaxMin.min : 0; // 0
                let max = productivityMaxMin ? productivityMaxMin.max : 0; // 100
                const scaled = d.row.productivity_mean.map((v: number) => {
                  //return (v - min) / (max - min) * 100;
                  return (v-12000) * scale * 100;
                });
                d.row.productivity_mean_transformed = scaled;
            }
            return d;
        });

        const _data = _dataAllZones.find((d:any) => d.zone_id === selectedZoneId);

        if (!_data) {
            return;
        }

        let statValue: StatValue = {
            name: metric,
            metric: metric,
            date: _data.dates[_data.dates.length-1],
            value: _data.values[_data.values.length-1],
            min: Math.min(..._data.values),
            max: Math.max(..._data.values),
            prevValue: _data.values.length > 1 ? _data.values[_data.values.length-2] : undefined,
            change: undefined,
            changeType: undefined,
            historical: _data.values,
            data: _data,
            dataAllZones: _dataAllZones,
        };

        if(statValue.prevValue) {
            statValue.change = (statValue.value - statValue.prevValue) / statValue.prevValue * 100;
            statValue.changeType = statValue.change  && statValue.change > 0 ? 'increase' : 'decrease';
        }
        console.log("B032924 statValue", statValue)
        console.log("XX041024 zoneData", zoneData);
        console.log("XX041024 metric", metric);
        console.log("XX041024 statValue", statValue);
        setZoneData((prevZoneData:any) => ({
            ...prevZoneData, // Spread the previous state to maintain other key-value pairs
            [metric]: statValue, // Add or update the "productivity" key
        }));


    }, [dataAllZones, selectedZoneId]);

    useEffect(() => {
        if(loading || !field) {
            return;
        }

        const definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('zone'));

        if(!definition) {
            console.error('Unable to find field definition');
            return;
        }else{
            console.log("B032924 definition", definition)
        }

        const key = [field.ext_id!, settings[SETTING_SEASON_YEAR], metric].join("_");
        console.log("XXX041024 field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition", field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition)
        //if(!cache.hasOwnProperty(key)) {
            setDataLoading(true);
            _load(field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition).then(result => { 
                //setData(result.filter((zone: any) => zone.zone_name === selectedZoneName);
                
                setDataAllZones(result);
                setDataLoading(false);
                cache[key] = result;
            });
        /*} else {
            if(Object.keys(cache).length > CACHE_SIZE) {
                for(const k in cache) {
                    delete cache[k];
                }
            }
            setData(cache[key]);
        }*/

    }, [loading, metric, /*selectedZoneSetId, field, dateSelected, selectedZoneName,*/ zones, settings[SETTING_SEASON_YEAR], selectedZoneSetId/*, field*/]);

    const _load = async (extId: number, year: number, metric: string, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;

        const data = await queryDwZoneMetric(extId, definition, metric, dtStart, dtEnd, selectedZoneSetId);
        console.log("B040124 data", data)
        console.log(`B050624 queryDwZoneMetric ${metric}`, data)
        if(data) {
            return data;
        }

        return null;
    }

    return (
         <Widget title={name} showHeader={false} renderActions={() => (<></>)}>
            <Stats year={settings[SETTING_SEASON_YEAR]} dateSelected={dateSelected} context={"zone"} loading={dataLoading} metric={name} description={description} data={zoneData ? zoneData[metric] : null} changeInverted={changeInverted} />
        </Widget>
    )
}

export default DwZoneStatWidget;